import { PageRef } from 'providers/page-ref';

export type AdminUserSubscriptionPageParams = {
  id?: string;
};

export const IAdminUserSubscriptionPage: PageRef<AdminUserSubscriptionPageParams, void> = {
  pageName: 'AdminUserSubscriptionPage',
} as PageRef<AdminUserSubscriptionPageParams, void>;
